import React from 'react';
import styled from 'styled-components';
import ContextProvider from '../vehicle-context';
import ColumnPreview from './column';
import RowPreview from './row';

const PreviewComponent = ({ className, layout, ...props }) => {
  const Preview = layout === 'row' ? RowPreview : ColumnPreview;
  return (
    <ContextProvider {...props}>
      <Preview className={className} />
    </ContextProvider>
  );
};

export default styled(PreviewComponent)``;
